var agp = agp || {};

agp.boxes = (function() {
	var started = false;


	function init (domain) {
		$(domain || '.js--focus-box-info-domain').each(function() {
			var container = $(this);

			container
				.off('click')
				.on('click', '.focus-box--info', function(event) {
					event.preventDefault();

					var box = $(this),
						targets = container.find('.info-box--id-' + box.data('focus-box-info')),
						isOpen;

					isOpen = box.hasClass('focus-box--info-active');

					container.find('.focus-box--info').removeClass('focus-box--info-active');
					container.find('.info-box--target').removeClass('info-box--active');

					if (!isOpen) {
						box.addClass('focus-box--info-active');
						targets.addClass('info-box--active');
					}
				});
		});

		agp.boxes.setColors();
	}

	function setColors(container) {
		if (started) {
			return;
		}
		started = true;

		container = container || document.body;

		var colors = [];
		colors[0] = ["2", "4", "1", "4"];
		colors[1] = ["4", "1", "2", "11"];
		colors[2] = ["2", "11", "4", "1"];


		var rowIndex = 0;
		var colorIndex = 0;
		var collections = $(".js--gradient-collection", container);
		collections.each(function() {
			var $row = $(this),
			ignoreLast;
			
			$row.find(".gradient").each(function() {
				var $item = $(this);

				var color = colors[rowIndex][colorIndex];
				var cssClass = $item.attr("class");
				var match = cssClass.match(/\bgradient--[0-9]|[0-9][0-9]\b/);

				if (!$item.data('setColors.init') && match) {
					$item.data('setColors.ignore', ignoreLast ? false : true);
				}
				$item.data('setColors.init', true)

				if (!$item.data('setColors.ignore')) {
					if (match) {
						$item.removeClass(match.join(' '));
					}
					$item.addClass("gradient--" + color);
				}

				colorIndex++;
				if (colorIndex > colors[rowIndex].length - 1) {
					colorIndex = 0;
				}

				ignoreLast = $item.data('setColors.ignore');
			});
			rowIndex++;
			colorIndex = 0;
			if (rowIndex > 2) {
				rowIndex = 0;
			}
		});

		started = false;
	}

	return {
		init: init,
		setColors: setColors
	};
}());